<footer class="site-footer" aria-label="Site footer">
    <div class="container-xxl">
        <div class="footer-premium-surface" appReveal #footerSurface>
            <div class="footer-top-row">
                <div class="footer-brand-column">
                    <img src="assets/logo/Articix-Transparent-BG.png" alt="Articix logo" class="footer-logo" width="160" height="50">
                    <p class="footer-tagline">
                        Engineering Excellence for the Global Enterprise.
                    </p>
                    <div class="footer-socials" aria-label="Articix social media links">
                        <a class="btn-social" href="https://www.youtube.com/@articix" target="_blank" rel="noopener" aria-label="Articix YouTube Channel"><i class="fa-brands fa-youtube"></i></a>
                        <a class="btn-social" href="https://www.facebook.com/articixglobal" target="_blank" rel="noopener" aria-label="Articix Facebook Page"><i class="fab fa-facebook-f"></i></a>
                        <a class="btn-social" href="https://www.instagram.com/articixglobal/" target="_blank" rel="noopener" aria-label="Articix Instagram Profile"><i class="fab fa-instagram"></i></a>
                        <a class="btn-social" href="https://x.com/@articixglobal" target="_blank" rel="noopener" aria-label="Articix X Twitter Account"><i class="fa-brands fa-x-twitter"></i></a>
                    </div>
                </div>

                <nav class="footer-nav-grid" aria-label="Footer navigation">
                    <div class="footer-nav-col">
                        <h4>Company</h4>
                        <ul class="footer-links">
                            <li><a routerLink="/who-we-are">Who We Are</a></li>
                            <li><a routerLink="/company/leadership">Leadership</a></li>
                            <li><a routerLink="/company/values">Core Values</a></li>
                            <li><a routerLink="/company/sustainability">Sustainability</a></li>
                            <li><a routerLink="/company/newsroom">Newsroom</a></li>
                            <li><a routerLink="/careers">Careers</a></li>
                            <li><a routerLink="/investor-relations">Investor Relations</a></li>
                        </ul>
                    </div>
                    <div class="footer-nav-col">
                        <h4>Solutions</h4>
                        <ul class="footer-links">
                            <li><a routerLink="/what-we-do">What We Do</a></li>
                            <li><a routerLink="/ai-automation">AI & Automation</a></li>
                            <li><a routerLink="/services">Cloud Engineering</a></li>
                            <li><a routerLink="/industries">Industry Verticals</a></li>
                        </ul>
                    </div>
                    <div class="footer-nav-col">
                        <h4>Resources</h4>
                        <ul class="footer-links">
                            <li><a routerLink="/insights">Insights Hub</a></li>
                            <li><a routerLink="/insights/customer-stories">Customer Stories</a></li>
                            <li><a routerLink="/insights/global-studies">Global Studies</a></li>
                            <li><a routerLink="/insights/analyst-recognition">Analyst Recognition</a></li>
                            <li><a routerLink="/trust-center">Trust Center</a></li>
                            <li><a routerLink="/responsible-ai">Responsible AI</a></li>
                        </ul>
                    </div>
                </nav>

                <div class="footer-newsletter-col">
                    <h4>Stay Ahead</h4>
                    <p>Subscribe to receive curated technology insights for enterprise leaders.</p>
                    @if (successText()) {
                        <div class="news-success-msg" appReveal role="alert">
                            <i class="fa-solid fa-circle-check"></i>
                            <span>Successfully subscribed to Articix Insights!</span>
                        </div>
                    } @else {
                        <form [formGroup]="newsForm" (submit)="onSubmit()" class="footer-news-form">
                            <label for="footer-email-input" class="visually-hidden">Business Email Address</label>
                            <div class="input-group-premium">
                                <input id="footer-email-input" type="email" formControlName="email" placeholder="Business Email" autocomplete="email" aria-label="Business Email">
                                <button type="submit" aria-label="Subscribe to newsletter"><i class="fa-solid fa-paper-plane"></i></button>
                            </div>
                        </form>
                    }
                </div>
            </div>

            <div class="footer-bottom-row">
                <nav class="footer-legal" aria-label="Legal navigation">
                    <a routerLink="/privacy-policy">Privacy Policy</a>
                    <a routerLink="/terms-of-use">Terms of Use</a>
                    <a routerLink="/cookie-policy">Cookie Policy</a>
                    <a routerLink="/accessibility-statement">Accessibility</a>
                </nav>
                <div class="footer-copyright">
                    &copy; {{ currentYear }} ARTICIX GLOBAL. All rights reserved.
                </div>
            </div>
        </div>
    </div>
</footer>
